// composables/useGlobalLoading.js
export const useGlobalLoading = () => {
  const isGlobalLoading = useState('globalLoading', () => false);
  const globalLoadingMessage = useState(
    'globalLoadingMessage',
    () => 'Loading...'
  );

  const showGlobalLoading = (message = 'Loading...') => {
    globalLoadingMessage.value = message;
    isGlobalLoading.value = true;
  };

  const hideGlobalLoading = () => {
    isGlobalLoading.value = false;
    globalLoadingMessage.value = 'Loading...';
  };

  return {
    isGlobalLoading: readonly(isGlobalLoading),
    globalLoadingMessage: readonly(globalLoadingMessage),
    showGlobalLoading,
    hideGlobalLoading,
  };
};
